import { acConfig } from '../../declarations';

export const isInContainer = (): boolean =>
  !!acConfig.containerFrontendUrl &&
  window.location.origin.startsWith(acConfig.containerFrontendUrl);
